<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="portfolio" class="portfolio">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <!-- <div class="row" data-aos="fade-up" data-aos-delay="100"> -->
    <!--   <div class="col-lg-12 d-flex justify-content-center"> -->
    <!--     <ul id="portfolio-flters"> -->
    <!--       <li data-filter="*" class="filter-active">All</li> -->
    <!--       <li data-filter=".filter-app">App</li> -->
    <!--       <li data-filter=".filter-card">Card</li> -->
    <!--       <li data-filter=".filter-web">Web</li> -->
    <!--     </ul> -->
    <!--   </div> -->
    <!-- </div> -->

    <div class="row gy-4 portfolio-container" data-aos="fade-up" data-aos-delay="200">

      {#each blocklist(block, 'items') as item}
      <div class="col-lg-4 col-md-6 portfolio-item filter-app">
        <div class="portfolio-wrap">
          <img src="{image(item, 'picture', [500, 500])}" class="img-fluid" alt="">
          <div class="portfolio-info">
            <h4>{text(item, 'title')}</h4>
            <p>{text(item, 'subtitle')}</p>
            <div class="portfolio-links">
              <a href="{image(item, 'picture')}" data-gallery="portfolioGallery" class="portfokio-lightbox" title="{text(item, 'title')}">
                <i class="bi bi-plus"></i>
              </a>
              {#if exists(item, 'url')}
              <a href="{url(item, 'url')}" title="More Details"><i class="bi bi-link"></i></a>
              {/if}
            </div>
          </div>
        </div>
      </div>
      {/each}

    </div>

  </div>

</section>
